export default __webpack_public_path__ + "static/media/gabriela.33591cbf.webp";